import { render } from "./popBannerModal.vue?vue&type=template&id=1541a027&ts=true"
import script from "./popBannerModal.vue?vue&type=script&lang=ts"
export * from "./popBannerModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__